import { render, staticRenderFns } from "./CommunicationDetails.vue?vue&type=template&id=7e3bafb6"
import script from "./CommunicationDetails.vue?vue&type=script&lang=js"
export * from "./CommunicationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports